import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StyledComponent } from '@emotion/styled';
import { Colors } from '../../../constants';

export const RadioFormLabel: StyledComponent<FormControlLabelProps> = styled(
	(props: FormControlLabelProps) => (
		<FormControlLabel {...props} />
	)
)(() => ({
	marginLeft: 0,
	gap: '12px',

	'& .MuiFormControlLabel-label': {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '124%',
		color: Colors.white,
	}
}));
